export const optionsPackerOrder = (t) => {
    return [
        {
            aclCode: 'packer_order_header',
            key: 'packer_order',
            label: 'Packer Order',
            children: [
                {
                    aclCode: 'packer_order_list',
                    key: 'packer_order_list',
                    label: 'Packer Order List',
                    url: '/packerorder/list',
                },
                {
                    aclCode: 'packer_order_report',
                    key: 'packer_order_report',
                    label: 'Export Report',
                    url: '/packerorder/report',
                },
            ],
        },
    ];
};